import { render, staticRenderFns } from "./BoxPerformanceComparisonLineRegion.vue?vue&type=template&id=bc0694b2&scoped=true&"
import script from "./BoxPerformanceComparisonLineRegion.vue?vue&type=script&lang=js&"
export * from "./BoxPerformanceComparisonLineRegion.vue?vue&type=script&lang=js&"
import style0 from "./BoxPerformanceComparisonLineRegion.vue?vue&type=style&index=0&id=bc0694b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0694b2",
  null
  
)

export default component.exports
import {QCard,QBtnToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtnToggle})
